<template>
  <section v-adjust-height class="flex flex-col select-none bg-gray-50 overflow-auto">
    <div class="flex flex-col">

        <div class="px-6 py-5 text-sm text-gray-400">
            <h1 class="text-xl font-medium text-secondary">Indberetninger</h1>
        </div>

        <ul class="space-y-4">
            <li v-for="(item, index) in dashboardItems" :key="index">
                <a @click="goto(item.path)" class="flex items-center bg-white text-sm text-gray-400 cursor-pointer">
                    <div class="grow px-6 py-5">
                        <h1 class="text-xl font-medium text-secondary">{{ item.title }}</h1>
                        <div class="text-sm font-medium text-blue-900">{{ item.description }}</div>
                    </div>
                    <div class="shrink-0 px-6">
                        <svg width="9" height="40" viewBox="0 0 9 40" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.02899 20.4773L2.56306 25.9432C2.29944 26.2068 1.87206 26.2068 1.60847 25.9432L0.97096 25.3057C0.707794 25.0425 0.707288 24.616 0.969835 24.3522L5.30168 20L0.969835 15.6478C0.707288 15.384 0.707794 14.9575 0.97096 14.6943L1.60847 14.0568C1.87208 13.7932 2.29947 13.7932 2.56306 14.0568L8.02896 19.5227C8.29257 19.7863 8.29257 20.2137 8.02899 20.4773Z"
                                fill="#E5E7EB" />
                        </svg>
                    </div>
                </a>
            </li>
        </ul>
      </div>
  </section>
</template>

<script lang='ts'>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'reportsOverview',
  components: {

  },
  data () {
    return {
      dashboardItems: [
        {
          title: 'Timeseddel',
          description: 'Indberetning af projekt timer',
          type: 'time',
          path: '/reports/week/time'
        },
        {
          title: 'Transport',
          description: 'Indberetning af transport tid og Km.',
          type: 'transport',
          path: '/reports/week/transport'
        },
        // {
        //   title: 'Diæter',
        //   description: 'Indberetning af diæter',
        //   type: 'diet',
        //   path: '/reports/create/diet'
        // },
        {
          title: 'Sygdom',
          description: 'Indberetning af sygdom',
          type: 'sickness',
          path: '/reports/week/sick'
        }
      ]
    }
  },
  setup () {
    const router = useRouter()
    const goto = (path: string) => {
      router.push(path)
    }
    return { goto }
  }
})
</script>
